export const getAppLinkForBuildType = () => {
  return 'http://hyperurl.co/8ziigl';
};

export const getPlayStoreLinkForBuildType = () => {
  return 'https://play.google.com/store/apps/details?id=co.uk.davidlloyd.mobileapp';
};

export const getAppStoreLinkForBuildType = () => {
  return 'https://apps.apple.com/gb/app/david-lloyd-clubs/id1037992616';
};

export const isExternalLink = (link: string): boolean => {
  return link?.startsWith('http://') || link?.startsWith('https://') || link?.startsWith('www.');
};

export const isJumpLink = (link: string): boolean => link.startsWith('#');
